<template>
  <div></div>
</template>

<script>
const converter = new showdown.Converter();

function render(text)
{
    return converter.makeHtml(text);
}

export default {
  name: "MDPage",
  props: {
    path: String
  },
  data() {
    return {
      data: ""
    };
  },
  mounted() {
    superagent
      .get(`/docfiles/${this.$props.path}`)
      .then(res => res.text)
      .then(data => {
        this.data = render(data);
        this.$el.innerHTML = this.data;
        this.$el.querySelectorAll("pre code").forEach(block => {
          hljs.highlightBlock(block);
          block.style = "text-align:left;border-radius: 0.5em;margin-left: auto;margin-right: auto;";
        });
      });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
